window.field_data = {
    "data": [{
        "fieldname": "PPSET2 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 2,
        "minimumfiles": 2,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 2"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET1 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality file here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 1,
        "minimumfiles": 1,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 1"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET3 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 3,
        "minimumfiles": 3,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 3"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET4 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 4,
        "minimumfiles": 4,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 4"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET5 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 5,
        "minimumfiles": 5,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 5"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET6 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 6,
        "minimumfiles": 6,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 6"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET8 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 8,
        "minimumfiles": 8,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload a file!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 8"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET10 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 10,
        "minimumfiles": 10,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 10"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET12 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 12,
        "minimumfiles": 12,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 12"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET16 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 16,
        "minimumfiles": 16,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 16"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET24 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 24,
        "minimumfiles": 24,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 24"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET32 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 32,
        "minimumfiles": 32,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 32"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET36 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 36,
        "minimumfiles": 36,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 36"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET48 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 48,
        "minimumfiles": 48,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 48"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET50 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 50,
        "minimumfiles": 50,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 50"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET75 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 75,
        "minimumfiles": 75,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 75"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05)",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PPSET100 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 100,
        "minimumfiles": 100,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Classic Prints", "Large Prints", "Photo Prints", "Polaroids", "Square Prints"],
            "collectionIds": ["gid://shopify/Collection/449246232829", "gid://shopify/Collection/449647411453", "gid://shopify/Collection/449022722301", "gid://shopify/Collection/449382973693", "gid://shopify/Collection/449246200061"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Quantity//?//Set of 100"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449246232829",
            "title": "Classic Prints"
        }, {
            "id": "gid://shopify/Collection/449647411453",
            "title": "Large Prints"
        }, {
            "id": "gid://shopify/Collection/449022722301",
            "title": "Photo Prints"
        }, {
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }, {
            "id": "gid://shopify/Collection/449246200061",
            "title": "Square Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "POLA10 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 10,
        "minimumfiles": 10,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Polaroids"],
            "collectionIds": ["gid://shopify/Collection/449382973693"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Set of//?//10"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "POLA20 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 20,
        "minimumfiles": 20,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Polaroids"],
            "collectionIds": ["gid://shopify/Collection/449382973693"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Set of//?//20"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "POLA30 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 30,
        "minimumfiles": 30,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Memoroids"],
            "collectionIds": ["gid://shopify/Collection/449382973693"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Set of//?//30"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\u200b"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449382973693",
            "title": "Memoroids",
            "imageSrc": ""
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "POLA50 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 50,
        "minimumfiles": 50,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Polaroids"],
            "collectionIds": ["gid://shopify/Collection/449382973693"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Set of//?//50"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "POLA75 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 75,
        "minimumfiles": 75,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Polaroids"],
            "collectionIds": ["gid://shopify/Collection/449382973693"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Set of//?//75"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "POLA100 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 100,
        "minimumfiles": 100,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Polaroids"],
            "collectionIds": ["gid://shopify/Collection/449382973693"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Set of//?//100"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "PSHEET Uploaded Picture",
        "directUpload": false,
        "atcTitle": "Upload high quality file here (we will remove background):",
        "uploadButtonText": "Upload File",
        "uploadButtonText2": "Change File",
        "dialogInstructionOne": "Just upload a clear front-facing photo - we\u2019ll handle the background edits.",
        "dialogInstructionTwo": "Just upload a clear front-facing photo - we\u2019ll handle the background edits.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": true,
        "op2": false,
        "maximumFiles": 1,
        "minimumfiles": 1,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload a file!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Passport & Stamp Prints"],
            "collectionIds": ["gid://shopify/Collection/449300726013"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": true,
        "anyConditionVariant": false,
        "allConditionVariant": false,
        "noneConditionVariant": false,
        "allVariantValues": [],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449300726013",
            "title": "Passport & Stamp Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "CAN1 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality file here",
        "uploadButtonText": "Upload File",
        "uploadButtonText2": "Change File",
        "dialogInstructionOne": "Ensure the uploaded file will fit into the selected size",
        "dialogInstructionTwo": "Ensure the uploaded file will fit into the selected size",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": true,
        "op2": false,
        "maximumFiles": 1,
        "minimumfiles": 1,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload a file!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "crop_free",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Canvas Frames", "Rolled Canvas Prints"],
            "collectionIds": ["gid://shopify/Collection/449408303357", "gid://shopify/Collection/449301414141"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": true,
        "anyConditionVariant": false,
        "allConditionVariant": false,
        "noneConditionVariant": false,
        "allVariantValues": [],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449408303357",
            "title": "Canvas Frames"
        }, {
            "id": "gid://shopify/Collection/449301414141",
            "title": "Rolled Canvas Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "POLSTRIP2 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 2,
        "minimumfiles": 2,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Polaroids"],
            "collectionIds": ["gid://shopify/Collection/449382973693"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Image Count//?//2"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "POLSTRIP3 Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 3,
        "minimumfiles": 3,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["Polaroids"],
            "collectionIds": ["gid://shopify/Collection/449382973693"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": false,
        "anyConditionVariant": false,
        "allConditionVariant": true,
        "noneConditionVariant": false,
        "allVariantValues": ["Equals//?//Image Count//?//3"],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449382973693",
            "title": "Polaroids"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "ILLUST Uploaded Pictures",
        "directUpload": false,
        "atcTitle": "Upload high quality files here :",
        "uploadButtonText": "Upload Files",
        "uploadButtonText2": "Change Files",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 3,
        "minimumfiles": 1,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Enable",
        "textFieldName": "Text",
        "fieldHelpText": "Mention here \"Name & Position\" to be printed on print (leave blank if not wanted). This will be printed on the frame at top or bottom. Also mention if any preference of background color, background will be designed accordingly.",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload files!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": [],
            "productIds": [],
            "collection": ["illustrations"],
            "collectionIds": ["gid://shopify/Collection/449616576765"],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": true,
        "anyConditionVariant": false,
        "allConditionVariant": false,
        "noneConditionVariant": false,
        "allVariantValues": [],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": false,
        "thisCollection": true,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;\nbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
        },
        "targetingType": "expert",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Collection/449616576765",
            "title": "illustrations"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }, {
        "fieldname": "FLOOR1",
        "directUpload": false,
        "atcTitle": "Upload high quality file here :",
        "uploadButtonText": "Upload File",
        "uploadButtonText2": "Change File",
        "dialogInstructionOne": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t. ",
        "dialogInstructionTwo": "Cropping optional \u2013 tap to crop (Choose right ratio). We\u2019ll crop to fit if you don\u2019t.",
        "dialogInstructionThree": "If you have trouble uploading, click \u22ee in the top right, then \u2018Open in Chrome\u2019",
        "buttonTextSize": 14,
        "buttonFontSize": 14,
        "fontStyle": "Theme Font",
        "introTitleColor": "#000",
        "buttonCol": "#ffffff",
        "buttonBg": "#027ed7",
        "buttonTopBottomPadding": "16",
        "buttonLeftRightPadding": "40",
        "buttonBorderRadius": "0",
        "buttonWidth": "Auto",
        "buttonDialogLang": "English",
        "dialogLanguage": "en",
        "opt1": false,
        "op2": true,
        "maximumFiles": 1,
        "minimumfiles": 1,
        "opt3": false,
        "fopt1": true,
        "fopt2": false,
        "fopt3": false,
        "pdf": false,
        "word": false,
        "customFile": false,
        "fileTypes": [],
        "buttonStatus": "Disable",
        "textFieldName": "Notes:",
        "fieldHelpText": "",
        "textFieldMaxLength": "No",
        "textFieldMaxChars": "30",
        "textFieldRequired": "No",
        "textFieldRequiredMessage": "Please enter a text!",
        "textFieldrequiredMessageButtonText": "OK",
        "fileSizeRestriction": false,
        "fileSizeRestrictionType": "minimumFileRestriction",
        "fileSizeMinimumRestriction": "2",
        "fileSizeMaximumRestriction": "4",
        "fileSizeMinMaxMinimum": "2",
        "fileSizeMinMaxMaximum": "4",
        "no": false,
        "yes": true,
        "fileRequiredMessage": "Please upload a file!",
        "fileRequiredMessageButtonText": "OK",
        "allowCropping": true,
        "croppingType": "aspect_ratio",
        "croppingAspectRatio": "1:1, 2:3, 3:4, 4:5, 5:6, 5:7",
        "allowEditing": true,
        "editingType": "optional",
        "buttonStatus2": "Disable",
        "imageWidth": "1800",
        "imageHeight": "1200",
        "maxSizeRestriction": "Disable",
        "maxImageWidth": "1800",
        "maxImageHeight": "1200",
        "selectedUploadSources": "file url gdrive gphotos dropbox onedrive",
        "productCondition": {
            "condition": "",
            "products": ["Floor Plan Prints"],
            "productIds": ["gid://shopify/Product/8910207516925"],
            "collection": [],
            "collectionIds": [],
            "prodOpt": "",
            "prodTitleEqual": [],
            "prodTitleContains": [],
            "collOpt": "",
            "collectionTitleEqual": [],
            "collectionTitleContains": []
        },
        "allVariants": true,
        "anyConditionVariant": false,
        "allConditionVariant": false,
        "noneConditionVariant": false,
        "allVariantValues": [],
        "anyConditionCheck": false,
        "allConditionCheck": false,
        "showAllFields": false,
        "thisProduct": true,
        "thisCollection": false,
        "ucCustomTransalations": {
            "uploading": "Uploading... Please wait.",
            "loadingInfo": "Loading info...",
            "errors_default": "Error",
            "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
            "errors_baddata": "Incorrect value",
            "errors_size": "File too big",
            "errors_upload": "Can't upload",
            "errors_user": "Upload canceled",
            "errors_info": "Can't load info",
            "errors_image": "Only images allowed",
            "draghere": "Drop a file here",
            "one": "1 file",
            "file_other": "1 files",
            "buttons_cancel": "Cancel",
            "buttons_remove": "Remove",
            "buttons_choose_files_one": "Choose a file",
            "buttons_choose_files_other": "Choose files",
            "buttons_choose_images_one": "Choose an image",
            "buttons_choose_images_other": "Choose images",
            "dialog_close": "Close",
            "dialog_done": "Done",
            "dialog_showFiles": "Show files",
            "dialog_tabs_names_preview": "Preview",
            "dialog_tabs_names_file": "Local Files",
            "dialog_tabs_names_url": "Direct Link",
            "dialog_tabs_names_file_drag": "drag & drop<br>any files",
            "dialog_tabs_names_file_or": "or",
            "dialog_tabs_names_file_also": "or choose from",
            "dialog_tabs_names_file_button": "Choose a local file",
            "dialog_tabs_names_url_title": "Files from the Web",
            "dialog_tabs_names_url_line2": "Provide the link.",
            "dialog_tabs_names_url_input": "Paste your link here...",
            "dialog_tabs_names_url_button": "Upload",
            "dialog_tabs_names_camera_title": "File from web camera",
            "dialog_tabs_names_camera_capture": "Take a photo",
            "dialog_tabs_names_camera_mirror": "Mirror",
            "dialog_tabs_names_camera_startRecord": "Record a video",
            "dialog_tabs_names_camera_stopRecord": "Stop",
            "dialog_tabs_names_camera_retry": "Request permissions again",
            "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
            "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
            "notFound_title": "No camera detected",
            "notFound_text": "Looks like you have no camera connected to this device.",
            "dialog_tabs_names_preview_back": "Back",
            "dialog_tabs_names_preview_done": "Add",
            "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
            "dialog_tabs_names_preview_regular_title": "Add this file?",
            "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
            "dialog_tabs_names_preview_regular_line2": "Please confirm.",
            "dialog_tabs_names_preview_image_title": "Add this image?",
            "dialog_tabs_names_preview_crop_title": "Crop and add this image",
            "dialog_tabs_names_preview_crop_free": "free",
            "dialog_tabs_names_preview_video_title": "Add this video?",
            "dialog_tabs_names_preview_error_default_title": "Oops!",
            "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
            "dialog_tabs_names_preview_error_default_back": "Please try again",
            "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
            "dialog_tabs_names_preview_multiple_question": "Add files?",
            "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
            "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
            "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
            "dialog_tabs_names_preview_multiple_clear": "Remove all",
            "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
            "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
            "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
            "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
            "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
            "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
            "effects_captions_blur": "Blur",
            "effects_captions_crop": "Crop",
            "effects_captions_enhance": "Enhance",
            "effects_captions_flip": "Flip",
            "effects_captions_grayscale": "Grayscale",
            "effects_captions_invert": "Invert",
            "effects_captions_mirror": "Mirror",
            "effects_captions_rotate": "Rotate",
            "effects_captions_sharp": "Sharpen",
            "effects_apply_button": "Apply"
        },
        "fileRequiredButton": "",
        "previewStyle": "container_preview",
        "customStyling": {
            "container": "background: #f5f7fa;\npadding: 20px;\nborder: 2px dashed #b0bec5;\nborder-radius: 2px;\n",
            "heading": "color: #37474f;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 4px;",
            "button": "background: linear-gradient(135deg, #027ed7, #42a5f5);\ncolor: #fff;\nborder: none;\nmargin-top: 6px;\npadding: 10px 20px;\nborder-radius: 2px;\nfont-weight: 600;\ncursor: pointer;\ntransition: all 0.3s ease;"
        },
        "targetingType": "beginner",
        "thisProductVariants": false,
        "selectedProducts": [{
            "id": "gid://shopify/Product/8910207516925",
            "title": "Floor Plan Prints"
        }],
        "fopt4": false,
        "fileExtensions": [],
        "pdf_settings": {
            "enabled": false,
            "minimum": 0,
            "maximum": 3
        },
        "translations": []
    }],
    "buy_button": false,
    "direct_link": false,
    "store_branding": false
};
